function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useAxios from "../../../../Hooks/use-axios";
import { addDealToCart, extractAmazonAsin, findCartItemByAsin, getCartData, updateDealInCart, WISHLIST_PINCODE_KEY } from "../../helpers/cart";

/** Pincode + Amazon URL input on /rewardStore; calls Winnre fetch-amazon-product and adds deal to cart. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AmazonWishlistInput(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
    winnreAuth = _ref.winnreAuth,
    _ref$isPoints = _ref.isPoints,
    isPoints = _ref$isPoints === void 0 ? false : _ref$isPoints,
    appType = _ref.appType,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux;
  var dispatch = redux.dispatch,
    dealAction = redux.dealAction;
  var _useAxios = useAxios({
      winnreAuth: winnreAuth
    }),
    isLoading = _useAxios.isLoading,
    sendRequest = _useAxios.sendRequest;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    pincode = _useState2[0],
    setPincode = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    amazonUrl = _useState4[0],
    setAmazonUrl = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    locationLabel = _useState6[0],
    setLocationLabel = _useState6[1];
  useEffect(function () {
    var savedPincode = localStorage.getItem(WISHLIST_PINCODE_KEY);
    if (savedPincode) {
      setPincode(savedPincode);
      lookupPincode(savedPincode);
    }
  }, []);
  var lookupPincode = function lookupPincode(value) {
    if (!/^\d{6}$/.test(value)) {
      setLocationLabel("");
      return;
    }
    fetch("https://api.postalpincode.in/pincode/".concat(value)).then(function (res) {
      return res.json();
    }).then(function (data) {
      var _data$;
      var postOffice = data === null || data === void 0 || (_data$ = data[0]) === null || _data$ === void 0 || (_data$ = _data$.PostOffice) === null || _data$ === void 0 ? void 0 : _data$[0];
      if (postOffice) {
        setLocationLabel("".concat(postOffice.District, ", ").concat(postOffice.State));
      } else {
        setLocationLabel("");
      }
    })["catch"](function () {
      return setLocationLabel("");
    });
  };
  var handlePincodeChange = function handlePincodeChange(event) {
    var value = event.target.value.replace(/\D/g, "").slice(0, 6);
    setPincode(value);
    if (value.length === 6) {
      localStorage.setItem(WISHLIST_PINCODE_KEY, value);
      lookupPincode(value);
    }
  };
  var handleSubmit = function handleSubmit() {
    if (!isAuthenticated) {
      toast.error("Please login to add Amazon products to your cart.");
      return;
    }
    if (!/^\d{6}$/.test(pincode)) {
      toast.error("Please enter a valid 6-digit pincode.");
      return;
    }
    var isAmazonLink = /amazon\.(in|com)|amzn\.(in|to)|a\.co/i.test(amazonUrl);
    if (!amazonUrl.trim() || !isAmazonLink) {
      toast.error("Please enter a valid Amazon product link.");
      return;
    }
    var asin = extractAmazonAsin(amazonUrl.trim());
    var cartData = getCartData(isPoints);
    var existingCartItem = asin ? findCartItemByAsin(cartData, asin) : null;
    var cartValue = cartData.totalPoints || 0;
    var rewardType = appType === "winnre" || isPoints ? "RELOY_REWARDS" : "REFERRAL_REWARDS";
    var url = "/winnre/user/deals/fetch-amazon-product?url=".concat(encodeURIComponent(amazonUrl.trim()), "&pincode=").concat(pincode, "&cartValue=").concat(cartValue, "&rewardType=").concat(rewardType);
    sendRequest({
      isEncryptedResponse: true,
      url: url,
      method: "post",
      isFormData: true
    }, function (deal) {
      if ((deal === null || deal === void 0 ? void 0 : deal.status) === "FAILED" || (deal === null || deal === void 0 ? void 0 : deal.status) === "UNAUTHORIZED") {
        toast.error((deal === null || deal === void 0 ? void 0 : deal.message) || "Failed to add product from Amazon.");
        return;
      }
      if (!(deal !== null && deal !== void 0 && deal.id)) {
        toast.error("Failed to add product from Amazon.");
        return;
      }
      var dealWithSku = _objectSpread(_objectSpread({}, deal), {}, {
        productSku: deal.productSku || asin
      });
      if (existingCartItem) {
        var refreshResult = updateDealInCart(_objectSpread(_objectSpread({}, dealWithSku), {}, {
          id: existingCartItem.id
        }), {
          dispatch: dispatch,
          dealAction: dealAction
        }, isPoints);
        if (refreshResult.updated) {
          toast.success("Cart price updated for this product.");
          setAmazonUrl("");
        } else {
          toast.info("This product is already in your cart.");
        }
        return;
      }
      var result = addDealToCart(dealWithSku, {
        dispatch: dispatch,
        dealAction: dealAction
      }, isPoints);
      if (result.added) {
        toast.success("Product added to cart.");
        setAmazonUrl("");
      } else if (result.reason === "already_in_cart") {
        var _refreshResult = updateDealInCart(dealWithSku, {
          dispatch: dispatch,
          dealAction: dealAction
        }, isPoints);
        if (_refreshResult.updated) {
          toast.success("Cart price updated for this product.");
          setAmazonUrl("");
        } else {
          toast.info("This product is already in your cart.");
        }
      }
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "mt-4 p-4 rounded-xl border border-[#E8E8EF] bg-[#FAFAFC]",
    children: [/*#__PURE__*/_jsx("p", {
      className: "text-sm font-semibold text-[#130E2F] mb-1",
      children: "Add from Amazon Wishlist"
    }), /*#__PURE__*/_jsx("p", {
      className: "text-xs text-gray-500 mb-3",
      children: "Enter your pincode for accurate price and availability in your area, then paste an Amazon product link."
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col lg:flex-row gap-3",
      children: [/*#__PURE__*/_jsx("input", {
        type: "text",
        inputMode: "numeric",
        disabled: isLoading,
        maxLength: 6,
        value: pincode,
        onChange: handlePincodeChange,
        placeholder: "Pincode",
        className: "w-full lg:w-40 px-3 py-2 border border-gray-300 rounded-lg text-sm"
      }), /*#__PURE__*/_jsx("input", {
        type: "url",
        disabled: isLoading,
        value: amazonUrl,
        onChange: function onChange(event) {
          return setAmazonUrl(event.target.value);
        },
        placeholder: "https://www.amazon.in/dp/...",
        className: "flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: handleSubmit,
        disabled: isLoading,
        className: "px-4 py-2 rounded-lg bg-primary text-white text-sm font-semibold disabled:opacity-60",
        children: isLoading ? "Adding to Cart..." : "Add to Cart"
      })]
    }), isLoading && /*#__PURE__*/_jsx("p", {
      className: "text-xs text-gray-500 mt-2",
      children: "Adding your Amazon item to the cart. This may take a few seconds."
    }), locationLabel && /*#__PURE__*/_jsxs("p", {
      className: "text-xs text-gray-500 mt-2",
      children: ["Delivering to: ", locationLabel]
    })]
  });
}
export default AmazonWishlistInput;